<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>건물정보</h3></li>
            <li>
              <element-select v-model="processorData.steps[0].formData.type.value" :error="processorData.steps[0].formData.type.error" :label="processorData.steps[0].formData.type.label" :placeholder="processorData.steps[0].formData.type.placeholder" :items="processorData.steps[0].formData.type.option" />
              <div class="select-caution" v-for="(option, index) in processorData.steps[0].formData.type.option" :key="index">
                <template v-if="option.value == processorData.steps[0].formData.type.value">
                  {{ option.description }}
                </template>
              </div>
            </li>
            <li @click="postcodeOpen">
              <element-textbox id="address" v-model="processorData.steps[0].formData.location.value" :error="processorData.steps[0].formData.location.error" :label="processorData.steps[0].formData.location.label" :placeholder="processorData.steps[0].formData.location.placeholder" />
            </li>
            <li>
              <element-textbox-auto-calculate :mode="'area'" 
              v-model="processorData.steps[0].formData.area.value" 
              :error="processorData.steps[0].formData.area.error" :label="processorData.steps[0].formData.area.label" :placeholder="processorData.steps[0].formData.area.placeholder" />
            </li>
          </ul>
          <div class="form-item-caution">해당 건물의 건축물대장, 등기부등본을 기준으로 전용면적(실면적)을 입력해주세요.</div>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li><element-select v-model="processorData.steps[1].formData.insureDuration.value" :error="processorData.steps[1].formData.insureDuration.error" :label="processorData.steps[1].formData.insureDuration.label" :placeholder="processorData.steps[1].formData.insureDuration.placeholder" :items="processorData.steps[1].formData.insureDuration.items" /></li>
            <li></li>
            <li></li>


            <li v-if="(processorData.steps[0].formData.type.value == '아파트' || processorData.steps[0].formData.type.value == '주택(연립 및 다세대)' || processorData.steps[0].formData.type.value == '주택(다가구 및 단독)' || processorData.steps[0].formData.type.value == '주택(목조)')" >
              <element-textbox-auto-calculate :mode="'building-price'" :area="processorData.steps[0].formData.area.value[1].value" v-model="processorData.steps[1].formData.residentialInsureOptions[0].value" :error="processorData.steps[1].formData.residentialInsureOptions[0].error" :label="processorData.steps[1].formData.residentialInsureOptions[0].label" :placeholder="processorData.steps[1].formData.residentialInsureOptions[0].placeholder" :dropbox="processorData.steps[1].formData.residentialInsureOptions[0].dropbox" />
              <element-select v-model="processorData.steps[1].formData.residentialInsureOptions[1].value" :error="processorData.steps[1].formData.residentialInsureOptions[1].error" :label="processorData.steps[1].formData.residentialInsureOptions[1].label" :placeholder="processorData.steps[1].formData.residentialInsureOptions[1].placehodler" :items="processorData.steps[1].formData.residentialInsureOptions[1].items" :dropbox="processorData.steps[1].formData.residentialInsureOptions[1].dropbox" />
            </li>

            <li v-if="(processorData.steps[0].formData.type.value == '상가 및 사무실' || processorData.steps[0].formData.type.value == '공장')" >
              <element-textbox-auto-calculate :mode="'building-price'" :area="processorData.steps[0].formData.area.value[1].value" v-model="processorData.steps[1].formData.commercialInsureOptions[0].value" :error="processorData.steps[1].formData.commercialInsureOptions[0].error" :label="processorData.steps[1].formData.commercialInsureOptions[0].label" :placeholder="processorData.steps[1].formData.commercialInsureOptions[0].placeholder"
              :dropbox="processorData.steps[1].formData.commercialInsureOptions[0].dropbox" />
              <element-textbox-have-price v-model="processorData.steps[1].formData.commercialInsureOptions[1].value" :error="processorData.steps[1].formData.commercialInsureOptions[1].error" :placeholder="processorData.steps[1].formData.commercialInsureOptions[1].placeholder" :label="processorData.steps[1].formData.commercialInsureOptions[1].label"/>
              <element-textbox-have-price v-model="processorData.steps[1].formData.commercialInsureOptions[2].value" :error="processorData.steps[1].formData.commercialInsureOptions[2].error" :placeholder="processorData.steps[1].formData.commercialInsureOptions[2].placeholder" :label="processorData.steps[1].formData.commercialInsureOptions[2].label"/>
              <element-textbox-have-price v-model="processorData.steps[1].formData.commercialInsureOptions[3].value" :error="processorData.steps[1].formData.commercialInsureOptions[3].error" :placeholder="processorData.steps[1].formData.commercialInsureOptions[3].placeholder" :label="processorData.steps[1].formData.commercialInsureOptions[3].label" :dropbox="processorData.steps[1].formData.commercialInsureOptions[3].dropbox"/>
            </li>

            <li v-for="(options, index) in processorData.steps[1].formData.residentialInsureOptions" :key="index">
              <template v-if="index >= 2 && (processorData.steps[0].formData.type.value == '아파트' || processorData.steps[0].formData.type.value == '주택(연립 및 다세대)' || processorData.steps[0].formData.type.value == '주택(다가구 및 단독)' || processorData.steps[0].formData.type.value == '주택(목조)')">
                <element-content-checkbox 
                @status="popup"
                v-model="processorData.steps[1].formData.residentialInsureOptions[index].value" 
                :error="processorData.steps[1].formData.residentialInsureOptions[index].error" 
                :label="processorData.steps[1].formData.residentialInsureOptions[index].label"
                :items="processorData.steps[1].formData.residentialInsureOptions[index].items" 
                :index="index" 
                :requirement="processorData.steps[1].formData.residentialInsureOptions[index].requirement"/>
              </template>
            </li>
            <li v-for="(options, index) in processorData.steps[1].formData.commercialInsureOptions" :key="index">
              <template v-if="index >= 4 && (processorData.steps[0].formData.type.value == '상가 및 사무실' || processorData.steps[0].formData.type.value == '공장')">
                <element-content-checkbox
                  @status="popup"
                  v-model="processorData.steps[1].formData.commercialInsureOptions[index].value"
                  :error="processorData.steps[1].formData.commercialInsureOptions[index].error"
                  :label="processorData.steps[1].formData.commercialInsureOptions[index].label"
                  :items="processorData.steps[1].formData.commercialInsureOptions[index].items"
                  :index="index"
                  :requirement="processorData.steps[1].formData.commercialInsureOptions[index].requirement" />
              </template>
            </li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[2]">
          <include-estimate-auth-self @updateprocessorData="updateprocessorData" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <ul class="form-item-list">
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[3].formData.consultDate.value" :error="processorData.steps[3].formData.consultDate.error" :label="processorData.steps[3].formData.consultDate.label" :placeholder="processorData.steps[3].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[3].formData.consultTime.value" :date="processorData.steps[3].formData.consultDate.value" :error="processorData.steps[3].formData.consultTime.error" :label="processorData.steps[3].formData.consultTime.label" :placeholder="processorData.steps[3].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[3].formData.consultRemark.value" :error="processorData.steps[3].formData.consultRemark.error" :label="processorData.steps[3].formData.consultRemark.label" :placeholder="processorData.steps[3].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[4]">
          <include-estimate-complete :data="processorData.steps[4]" />
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-other-estimate :data="processorData.steps[5]"  :type="processorData.title"/>
        </element-processor-step>
        <transition name="popup" v-if="statusPopup.popup">
          <element-popup @status="popup" v-model="processorData.steps[1].formData.residentialInsureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.residentialInsureOptions[statusPopup.option].items[statusPopup.index].label"
          v-if="statusPopup.popup && (processorData.steps[0].formData.type.value == '아파트' || processorData.steps[0].formData.type.value == '주택(연립 및 다세대)' || processorData.steps[0].formData.type.value == '주택(다가구 및 단독)' || processorData.steps[0].formData.type.value == '주택(목조)')"
          :subLabel="processorData.steps[1].formData.residentialInsureOptions[statusPopup.option].items[statusPopup.index].subLabel" :statusPopup="statusPopup" :data="processorData.steps[1].formData.residentialInsureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.residentialInsureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>

          <element-popup @status="popup" v-model="processorData.steps[1].formData.commercialInsureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.commercialInsureOptions[statusPopup.option].items[statusPopup.index].label"
          v-if="statusPopup.popup && (processorData.steps[0].formData.type.value == '상가 및 사무실' || processorData.steps[0].formData.type.value == '공장')"
          :subLabel="processorData.steps[1].formData.commercialInsureOptions[statusPopup.option].items[statusPopup.index].subLabel" :statusPopup="statusPopup" :data="processorData.steps[1].formData.commercialInsureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.commercialInsureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data(){
    return {
      statusPostcode: false,
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "화재보험 견적서",
        cureData: false,
        steps: [
          {
            title: "건물 정보",
            formData: {
              type: {
                label: "건물유형",
                value: "",
                error: "",
                placeholder: "건물유형 선택",
                option: [
                  { value: "아파트", label: "아파트", description: "아파트는 보통 내화구조로 되어있는 5층 이상의 건물입니다. 15층 이상은 특수건물로 지정되어 의무로 건물에 대한 보험금은 아파트 단체보험에서 가입을 하고 개인은 가재도구만 가입합니다." },
                  { value: "주택(연립 및 다세대)", label: "주택(연립 및 다세대)", description: "한 건물의 건축 연면적이 660m2를 초과하는 4층 이하인 주택입니다. 한 건물임에도 다수의 세대가 거주할 수 있는 주거 공간이 별도로 분리되어 있고 각 세대별로 등기를 별도로 하여 소유나 분양이 가능한 주택" },
                  { value: "주택(다가구 및 단독)", label: "주택(다가구 및 단독)", description: "주택으로 쓰이는 층수(지하층 제외)가 3개 층 이하이고 1개 동의 주택으로 쓰는 바닥 면적 합계가 660m2이하이며, 19세대 이하가 거주할 수 있는 주택" },
                  { value: "주택(목조)", label: "주택(목조)", description: "기둥, 벽, 지붕 중 하나라도 내화 구조 및 불연 재료가 아닌 목조 등으로 지어진 집입니다." },
                  { value: "상가 및 사무실", label: "상가 및 사무실", description: "병용 주택, 점포, 사무실 및 이들의 부속 선물 및 옥외설비, 장치, 공작물 또는 이들에 수용되는 가재, 집기비품, 재고 자산, 설치 기계 및 야적 동산, 숙박 시설 등이 포함됩니다." },
                  { value: "공장", label: "공장", description: "광업소, 발전소, 변전소 및 개폐소 포함 구내에 있는 건물, 공작물 및 이에 수용된 가재, 집기비품, 재고자산, 설치 기계 및 야적 동산, 제조 또는 가공 작업 및 기계, 기구류의 수리 또는 개조 작업 그리고 광석, 광유 및 천연 가스 채취 작업, 석유 정제 공장 구외에 소재한 저유소에서의 석유 및 석유 제품의 저장, 혼합 조성 및 압송 작업, 공장 물건 구내에 있는 기숙사를 포함합니다." }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              location: {
                label: "건물주소",
                value: "",
                error: "",
                placeholder: "건물주소 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              area: {
                label: "가입면적",
                value: [
                  { value: "", label: "미터" },
                  { value: "", lbael: "평" },
                ],
                error: "",
                placeholder: [
                  { value : "0", label: "0" },
                  { value : "0", label: "0" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "float", message: "숫자만 입력가능합니다" }
                ]
              },
            }
          },
          {
            title: "보장항목",
            formData:
            {
              insureDuration: {
                label: "보험 기간",
                value: "1년만기 1년납",
                error: "",
                placeholder: "보험 기간 / 납입 기간을 선택하세요",
                items: [
                  { value: "10년만기 10년납", label: "10년만기 10년납" },
                  { value: "5년만기 5년납", label: "5년만기 5년납" },
                  { value: "3년만기 3년납", label: "3년만기 3년납" },
                  { value: "1년만기 1년납", label: "1년만기 1년납" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              residentialInsureOptions: [
                {
                  label: "건물 가입금액",
                  value: [
                    { value: "", label: "만원" },
                    { value: "", label: "억원" },
                  ],
                  error: "",
                  dropbox: "가입 건물에 화재, 소방, 피난 손해 발생 시 실손보상",
                  placeholder: [
                    { value: "예 : 10000", label: "예 : 10000" },
                    { value: "1.5", label: "1.5" }
                  ],
                  validations: [
                    { type: "required", message: "필수항목입니다" },
                    { type: "float", message: "숫자만 입력가능합니다" }
                  ],
                  use: false,
                },
                {
                  label: "가재도구 가입금액",
                  value: "3억원",
                  error: "",
                  dropbox: "가입 가재도구에 화재, 소방, 피난 손해 발생 시 실손보상",
                  items: [
                    { value: "3억원", label: "3억원" },
                    { value: "1억원", label: "1억원" },
                    { value: "5,000만원", label: "5,000만원" },
                    { value: "3,000만원", label: "3,000만원" },
                    { value: "미가입", label: "미가입" }
                  ],
                  validations: [
                    { type: "required", message: "필수항목입니다" }
                  ],
                  use: false,
                },
                {
                  label: "추가특약",
                  requirement: false,
                  value: [],
                  error: "",
                  items: [
                    { value: "대물 배상책임", label: "대물 배상책임", description: [
                      { value: "가입한 목적물에 발생한 화재 또는 폭발사고로 타인을 사망케 하거나 부상을 입혀 혹은 타인의 재물에 손해를 입혀 법률상의 배상책임을 부담함으로써 입은 손해를 보상" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "사고당 5억", label: "사고당 5억" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "대인 배상책임", label: "대인 배상책임", description: [
                      { value: "가입한 목적물에 발생한 화재 또는 폭발사고로 타인을 사망케 하거나 부상을 입혀 혹은 타인의 재물에 손해를 입혀 법률상의 배상책임을 부담함으로써 입은 손해를 보상" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "1인당 1억", label: "1인당 1억" },
                        { value: "미가입", label: "미가입" },
                      ] },
                  ]
                }
              ],
              commercialInsureOptions: [
                {
                  label: "건물 가입금액",
                  value: [
                    { value: "", label: "만원" },
                    { value: "", label: "억원" },
                  ],
                  error: "",
                  dropbox: "가입 건물에 화재, 소방, 피난 손해 발생 시 실손보장",
                  placeholder: [
                    { value: "예 : 10000", label: "예 : 10000" },
                    { value: "1.5", label: "1.5" },
                  ],
                  validations: [
                    { type: "required", message: "필수항목입니다" },
                    { type: "float", message: "숫자만 입력가능합니다" }
                  ],
                  use: false,
                },
                {
                  label: "집기비품 가입금액",
                  value: "",
                  error: "",
                  placeholder: "3000",
                  validations: [
                    { type: "required", message: "필수항목입니다" },
                    { type: "number", message: "숫자만 입력가능합니다" }
                  ],
                  use: false,
                },
                {
                  label: "시설 및 인테리어",
                  value: "",
                  error: "",
                  placeholder: "4000",
                  validations: [
                    { type: "required", message: "필수항목입니다" },
                    { type: "number", message: "숫자만 입력가능합니다" }
                  ],
                  use: false,
                },
                {
                  label: "재고자산",
                  value: "",
                  error: "",
                  placeholder: "2000",
                  dropbox: "원부재료, 재공품, 반제품, 제품, 부산물과 상품 및 이와 유사한 것을 의미",
                  validations: [
                    { type: "required", message: "필수항목입니다" },
                    { type: "number", message: "숫자만 입력가능합니다" }
                  ],
                  use: false,
                },
                {
                  label: "추가특약",
                  requirement: false,
                  value: [],
                  error: "",
                  items: [
                    { value: "대물 배상책임", label: "대물 배상책임", description: [
                      { value: "가입한 목적물에 발생한 화재 또는 폭발사고로 타인을 사망케 하거나 부상을 입혀 혹은 타인의 재물에 손해를 입혀 법률상의 배상책임을 부담함으로써 입은 손해를 보상" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "사고당 5억", label: "사고당 5억" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "대인 배상책임", label: "대인 배상책임", description: [
                      { value: "가입한 목적물에 발생한 화재 또는 폭발사고로 타인을 사망케 하거나 부상을 입혀 혹은 타인의 재물에 손해를 입혀 법률상의 배상책임을 부담함으로써 입은 손해를 보상" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "1인당 1억", label: "1인당 1억" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "시설관리(소유)자 배상책임", label: "시설관리(소유)자 배상책임", description: [
                      { value: "공장, 사무실, 점포, 학교, 유원지, 간판 등 각종 시설의 소류, 사용 도는 관리의 수반으로 인해 생긴 우연한 사고로 제3자에게 손해를 끼친 경우에 입은 배상에 대해 보상하는 보험" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "가스사고 배상책임", label: "가스사고 배상책임", description: [
                      { value: "가스사업자, 용기 등 제ㅐ조업자, 가스사용자가 가스 폭발, 파열, 화재 및 누출로 타인의 신체, 재물을 손상케 한 경우 발생하는 법률상 배상책임을 보상하는 보험 입니다" }
                    ],subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "임차자 배상책임", label: "임차자 배상책임", description: [
                      { value: "피보험자가 임차한 부동산에 생긴 우연한 사고로 당해 부동산에 대하여 정당한 권리를 가지는 자(임대인)에게 부담하는 법률상 손해배상책임을 보상하는 보험" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "임대인 배상책임", label: "임대인 배상책임", description: [
                      { value: "임대해 준 보험증권에 기재된 주택에 생긴 우연한 사고로 타인의 신체의 장해 또는 재물의 손해에 대한 법률상의 배상책임을 부담함으로서 입은 손해가 발생한 경우 보상하는 보험" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "주차장 배상책임", label: "주차장 배상책임", description: [
                      { value: "피보험자가 소유, 사용, 관리하는 주차시설과 그 시설의 용도에 따른 주차업무 수행 중 주차를 목적으로 수탁받은 차량이나 타인에게 입힌 법률상 배상책임을 보상하는 보험" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "영업 배상책임", label: "영업 배상책임", description: [
                      { value: "영업활동을 수행하는 과정에서 발생한 사고로 인해 타인의 신체에 장해를 입히거나 타인의 재물을 망가뜨려 법률상의 손해배상책임을 부담함으로써 입은 손해를 보장하는 보험" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "재난 배상책임", label: "재난 배상책임", description: [
                      { value: "재난 및 안전관리 기본법에 따라 재난취약시설이 의무적으로 가입해야하는 보험으로 화재, 폭발, 붕괴 등으ㅇ로 인한 타인신체 또는 재산 피해를 보상하는 보험" }
                    ], subLabel: "미가입", link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                  ]
                }
              ]
            }
          },
          {
            title: "본인 확인",
            formData: {
              /*haslogin: {
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },*/
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
                /*validations: [
                  { type: "required", message: "-" }
                ]*/
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ] // steps
      }
    }
  },
  watch: {
    'processorData.steps.0.formData.type.value': function (n) {
      if(n === "상가 및 사무실" || n === "공장" ){
        this.processorData.steps[1].formData.commercialInsureOptions.forEach(o => {
          o.use = true;  
        })
        this.processorData.steps[1].formData.residentialInsureOptions.forEach(o => {
          o.use = false;  
        })
      }else{
        this.processorData.steps[1].formData.commercialInsureOptions.forEach(o => {
          o.use = false;  
        })
        this.processorData.steps[1].formData.residentialInsureOptions.forEach(o => {
          o.use = true;  
        })
      }
    }
  },

  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[3].formData.consultDate.value = date;
    }

    this.processorData.steps[3].formData.consultTime.value = time;
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[2].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[2].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );   
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      var insureOptionsObj = null;
      if(this.processorData.steps[0].formData.type.value == '아파트' ||
        this.processorData.steps[0].formData.type.value == '주택(연립 및 다세대)' || 
        this.processorData.steps[0].formData.type.value == '주택(다가구 및 단독)' || 
        this.processorData.steps[0].formData.type.value == '주택(목조)') {
      
          insureOptionsObj = this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option];
          /*
            this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;

            if(this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].value
              .findIndex(o => o.label === this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

              var index = this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
              if(value === '미가입' && !this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].requirement){
                this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].value.splice(index, 1);
              }
            }else{
              if(value != '미가입'){
                var tmp = { label: this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
                this.processorData.steps[1].formData.residentialInsureOptions[this.statusPopup.option].value.push( tmp )
              }
            }
          */
      }else{
        insureOptionsObj = this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option];
        /*
          this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].subLabel = value;
          
          if(this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].value
            .findIndex(o => o.label === this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].value) >= 0){

            var index = this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].value.findIndex(o => o.label === this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].value);
            if(value === '미가입' && !this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].requirement){
              this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].value.splice(index, 1);
            }
          }else{
            if(value != '미가입'){
              var tmp = { label: this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].items[this.statusPopup.index].value, value: value };
              this.processorData.steps[1].formData.commercialInsureOptions[this.statusPopup.option].value.push( tmp )
            }
          }
        */
      }

      insureOptionsObj.items[this.statusPopup.index].subLabel = value;

      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      if(Vidx >= 0){
        
        if(value === '미가입' && !insureOptionsObj.requirement){ 
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }

    },
    postcodeOpen() {
      var _this = this;
      new daum.Postcode({
        oncomplete: function(data) {
          _this.processorData.steps[0].formData.location.value = data.address
        }
      }).open();
    },
    updateprocessorData: function (data){
      //this.processorData.steps[2].formData.haslogin.value = data.haslogin;
      this.processorData.steps[2].formData.phone.value = data.phone;
      this.processorData.steps[2].formData.name.value = data.name;
      this.processorData.steps[2].formData.email.value = data.email;
      this.processorData.steps[2].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[2].formData.name.value },
            phone: { value: this.processorData.steps[2].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o
          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
